import baseTheme from './Themes/base';
import darkTheme from './Themes/dark';
import './types';

export default {
    baseTheme,
    darkTheme,
};
